import { useEffect, useState } from 'react';
import {
  getIngredients,
  getIngredientStocks,
  getIngredientIngredientTypes,
  getIngredientTypes,
  getLiquidClasses,
} from 'business/services/IngredientService';
import { IngredientTableRow } from '../IngredientConstants';
import { useRMSelector } from 'redux/hooks';

const useIngredientsList = () => {
  const [tableData, setTableData] = useState([]);
  const ingTableDataIndicator = useRMSelector(
    (state) => state.ingredientsTable.ingTableDataIndicator,
  );

  useEffect(() => {
    const fetchData = async () => {
      const resultArray = await Promise.all([
        getIngredients(),
        getIngredientStocks(),
        getIngredientIngredientTypes(),
        getIngredientTypes(),
        getLiquidClasses(),
      ]);

      const ingredients = resultArray[0];
      const ingredientStocks = resultArray[1];
      const ingredientIngredientTypes = resultArray[2];
      const ingredientTypes = resultArray[3];
      const liquidClasses = resultArray[4];

      const tableDataArray: IngredientTableRow[] = [];
      ingredients.forEach((_ingredient) => {
        const ingredientStocksFiltered = ingredientStocks.filter(
          (ingS) => ingS.ingredientId == _ingredient.id,
        );
        const highPhStock =
          ingredientStocksFiltered?.length &&
          ingredientStocksFiltered.reduce((previous, current) => {
            return current.stockPh > previous.stockPh ? current : previous;
          });
        const lowPhStock =
          ingredientStocksFiltered?.length &&
          ingredientStocksFiltered.reduce((previous, current) => {
            return current.stockPh < previous.stockPh ? current : previous;
          });

        const ingredientIngredientTypesFiltered = ingredientIngredientTypes.filter(
          (ingIngType) => ingIngType.ingredientId == _ingredient.id,
        );

        ingredientIngredientTypesFiltered.forEach((_ingIngType) => {
          const ingredientTypesFiltered = ingredientTypes.filter(
            (ingType) => ingType.id == _ingIngType.ingredientTypeId,
          );
          ingredientTypesFiltered.forEach((_ingType) => {
            if (_ingIngType.ingredientTypeId == _ingType.id) {
              const tableRow: IngredientTableRow = {} as IngredientTableRow;
              tableRow.id = _ingredient.id;
              tableRow.defaultBufferIngredientStockId =
                _ingredient.defaultBufferIngredientStockId;
              tableRow.defaultNonBufferIngredientStockId =
                _ingredient.defaultNonBufferIngredientStockId;
              tableRow.type = _ingType.name;
              tableRow.isBuffer = _ingType.isBuffer;
              tableRow.name = _ingredient.longName;
              tableRow.shortName = _ingredient.shortName;
              tableRow.stockConc = null;
              tableRow.defaultStockNumber = null;
              tableRow.concUnit = '';
              tableRow.lowConc = null;
              tableRow.highConc = null;
              tableRow.liquidClassName = '';
              tableRow.stockMinPh = null;
              tableRow.stockMaxPh = null;
              if (tableRow.isBuffer) {
                const ingredientStockData = ingredientStocks.find(
                  (ingS) => ingS.id == tableRow.defaultBufferIngredientStockId,
                );
                if (ingredientStockData) {
                  const liquidClassData = liquidClasses.find(
                    (liqC) => liqC.id == ingredientStockData.liquidClassId,
                  );
                  tableRow.stockId = ingredientStockData.id;
                  tableRow.stockConc = ingredientStockData.stockConcentration;
                  tableRow.defaultStockNumber = ingredientStockData.stockNumber;
                  tableRow.concUnit = ingredientStockData.concentrationUnits;
                  tableRow.lowConc = ingredientStockData.lowConcentration;
                  tableRow.highConc = ingredientStockData.highConcentration;
                  tableRow.liquidClassId = ingredientStockData.liquidClassId;
                  tableRow.liquidClassName = liquidClassData.name;
                  tableRow.stockMinPh = lowPhStock?.stockPh;
                  tableRow.stockMaxPh = highPhStock?.stockPh;
                }
              } else {
                const ingredientStockData = ingredientStocks.find(
                  (ingS) => ingS.id == tableRow.defaultNonBufferIngredientStockId,
                );
                if (ingredientStockData) {
                  const liquidClassData = liquidClasses.find(
                    (liqC) => liqC.id == ingredientStockData.liquidClassId,
                  );
                  tableRow.stockId = ingredientStockData.id;
                  tableRow.stockConc = ingredientStockData.stockConcentration;
                  tableRow.defaultStockNumber = ingredientStockData.stockNumber;
                  tableRow.concUnit = ingredientStockData.concentrationUnits;
                  tableRow.lowConc = ingredientStockData.lowConcentration;
                  tableRow.highConc = ingredientStockData.highConcentration;
                  tableRow.liquidClassId = ingredientStockData.liquidClassId;
                  tableRow.liquidClassName = liquidClassData.name;
                  tableRow.stockMinPh = null;
                  tableRow.stockMaxPh = null;
                }
              }
              tableDataArray.push(tableRow);
            }
          });
        });
      });
      setTableData(tableDataArray);
    };
    fetchData();
  }, [ingTableDataIndicator]);

  return tableData;
};

export default useIngredientsList;
